import { createContext } from "react";
import { AgencyState } from "./AgencyState";

export const AgencyContext = createContext<AgencyState>(null);
